import Dinero from "dinero.js";

export class Formatters {
  static formatAmount(amount: number, currency: any, lang: string = "fr"): string {
    return Dinero({ amount: amount, currency: currency })
      .setLocale(lang)
      .toFormat('$0,0');
  }
}